module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16,
      "offset": 4
    }
  }, [_c('el-card', {
    staticClass: "download"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://biophy.hust.edu.cn/download/nsp.tar.gz"
    }
  }, [_vm._v("Source code")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://biophy.hust.edu.cn/download/nsp-lib.tar.gz"
    }
  }, [_vm._v("Templates library")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0556be6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download.vue
// module id = 91
// module chunks = 2